import React from 'react';

function InputIcon() {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.8 12C20.8 9.85255 20.6229 7.87298 20.413 6.28408C20.2242 4.8541 19.1459 3.77581 17.7159 3.58695C16.127 3.37711 14.1475 3.2 12 3.2C9.85255 3.2 7.87298 3.3771 6.28408 3.58695C4.8541 3.77581 3.77581 4.85409 3.58695 6.28408C3.37711 7.87298 3.2 9.85254 3.2 12C3.2 14.1475 3.37711 16.127 3.58695 17.7159C3.77581 19.1459 4.8541 20.2242 6.28408 20.413C7.87298 20.6229 9.85254 20.8 12 20.8C14.1475 20.8 16.127 20.6229 17.7159 20.4131C19.1459 20.2242 20.2242 19.1459 20.413 17.7159C20.6229 16.127 20.8 14.1475 20.8 12ZM22.5941 5.99602C22.275 3.57955 20.4205 1.72504 18.004 1.40589C16.3427 1.18649 14.2646 0.999999 12 0.999999C9.7354 0.999999 7.65729 1.18649 5.99603 1.40589C3.57955 1.72503 1.72504 3.57955 1.40589 5.99602C1.18649 7.65729 1 9.7354 1 12C1 14.2646 1.18649 16.3427 1.40589 18.004C1.72504 20.4205 3.57955 22.275 5.99602 22.5941C7.65729 22.8135 9.7354 23 12 23C14.2646 23 16.3427 22.8135 18.004 22.5941C20.4204 22.275 22.275 20.4205 22.5941 18.004C22.8135 16.3427 23 14.2646 23 12C23 9.7354 22.8135 7.65729 22.5941 5.99602Z'
        fill='#565F67'
      />
      <path
        d='M9 8C8.44772 8 8 8.44772 8 9C8 9.55228 8.44772 10 9 10L11 10L11 15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15L13 10L15 10C15.5523 10 16 9.55229 16 9C16 8.44772 15.5523 8 15 8L9 8Z'
        fill='#565F67'
      />
    </svg>
  );
}

export default InputIcon;
